import { ChapterHeading, Reveal } from "./Reveal";
import { IMAGES, CONTACT } from "../config/site";

const AboutMarlene = () => (
  <section className="py-24 md:py-32 bg-sand" data-testid="about-section">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <ChapterHeading number="06" overline="Your Buyer's Agent" title="Someone in your corner — not the developer's." />

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 mt-14 md:mt-20 items-center">
        <Reveal className="lg:col-span-4">
          <div className="overflow-hidden aspect-[3/4] max-w-sm group" data-testid="marlene-photo-frame">
            <img
              src={IMAGES.marlene}
              alt="Marlene Alesna, REALTOR® with eXp Realty"
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700 ease-out"
              data-testid="marlene-photo"
            />
          </div>
        </Reveal>
        <div className="lg:col-span-8">
          <Reveal>
            <p className="text-xs tracking-[0.25em] uppercase font-semibold text-teal" data-testid="marlene-name">Marlene Alesna</p>
            <p className="font-serif text-2xl md:text-3xl font-light text-charcoal mt-3 leading-snug">
              REALTOR&reg; with eXp Realty &middot; Oahu-based buyer&rsquo;s agent
            </p>
            <p className="text-base text-stone2 leading-relaxed mt-6 max-w-2xl" data-testid="marlene-bio">
              Marlene is a Hawai&rsquo;i-local REALTOR&reg; with eXp Realty and The Agency Team Hawaii, based in Kailua on Oahu&rsquo;s windward side. She works with local, mainland, and military buyers &mdash; patient with first-timers, straight with everyone. On Kali&rsquo;u, her role is simple: she represents you, not the developer. She reads the fine print, tells you what she&rsquo;d actually do, and never rushes you into a decision.
            </p>
            <p className="mt-6 text-sm text-stone2">
              Hawai&rsquo;i License <span className="font-semibold text-charcoal" data-testid="license-number">RS-88409</span>
            </p>
            <a href={CONTACT.emailHref} className="inline-block mt-8 text-xs tracking-[0.2em] uppercase font-semibold text-teal border-b border-teal pb-1 hover:text-teal-deep hover:border-teal-deep transition-colors" data-testid="about-email-link">
              Introduce yourself
            </a>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);

export default AboutMarlene;

